(function(){

    document.addEventListener('DOMContentLoaded', () => {
        const grid = document.querySelector('#projects-grid');
        const group = document.querySelector('.js-project-filters');
        if (!grid || !group) return;

        group.addEventListener('click', (e) => {
            const btn = e.target.closest('button[data-filter]');
            if (!btn) return;

            const filter = btn.dataset.filter;
            const items = grid.querySelectorAll('.project-item');

            items.forEach(item => {
                if (filter === '*') {
                    item.classList.remove('is-hidden');
                } else {
                    const cls = filter.replace('.', '');
                    item.classList.toggle('is-hidden', !item.classList.contains(cls));
                }
            });

            group.querySelectorAll('button').forEach(b => b.classList.remove('is-checked'));
            btn.classList.add('is-checked');
        });
    });

})();
